import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { Checkbox, ICheckboxProps } from './Checkbox';

type Value = ICheckboxProps['value'];
type ICheckboxFieldProps = ICheckboxProps & FieldProps<Value, FieldRenderProps<Value>>;

export const CheckboxField = (props: ICheckboxFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      const error = typeof props.error === 'boolean' ? props.error && meta.error : meta.touched && meta.error;
      return <Checkbox {...props} {...input} error={error} />;
    }}
  </Field>
);
